import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/home/home.js";
import Walkin from "../pages/walkin/walkin";
import PCLM from "../pages/pclm/index.js";
import Disclaimer from "../pages/disclaimer/disclaimer.js";
import SignOn from "../pages/signon/signon.js";
import PrivateRoute from "./PrivateRoute.js";
import PrivateRouteQR from "./PrivateRouteQR.js";
import NotFound from "../pages/error/NotFound.js";

export default function Routing() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignOn />} />
      {/* <Route path="/walkincenter" element={<Walkin />} /> */}
      <Route path="/disclaimer" element={<Disclaimer />} />
      {/* <Route path="/test" element={<Home />} /> */}
      {/* <Route path="/testwk" element={<Walkin />} /> */}
      {/* <Route path="/testpclm" element={<PCLM />} /> */}

      <Route path="/">
        <Route index element={<Navigate to="/homepage" replace />} />
        <Route
          path="homepage"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="walkincenter"
          element={
            <PrivateRouteQR>
              <Walkin />
            </PrivateRouteQR>
          }
        />
        <Route
          path="pclm"
          element={
            <PrivateRouteQR>
              <PCLM />
            </PrivateRouteQR>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
